<template>
  <v-row :no-gutters="embed" justify="center">

    <!-- tool loading -->
    <v-overlay v-if="chartLoading && forceUnLoading!=true">
      <v-progress-circular indeterminate color="purple" size="70" width="7"></v-progress-circular>
    </v-overlay>
    <div v-else-if="chartLoading && forceUnLoading"></div>
    <!-- chart -->
    <v-col v-else cols="auto" class="text-center pa-0">
      <div :id="chartElId">
        <!-- <v-img v-if="!!dataSource" :src="dataSource" :width="imgw" contain></v-img> -->
        <img v-if="!!dataSource" :src="dataSource" :width="imgw" />
      </div>
    </v-col>
    <!-- <v-col v-if="!chartLoading && !embed" cols="12" class="text-center">
      <v-btn color="primary" @click="onExport" v-one-click>下 载</v-btn>
    </v-col> -->
  </v-row>
</template>
<script>
// R语言静态图片
import { userFileStream, userFileSpeedKey } from '@/plugins/api';
export default {
  props: ['forceUnLoading', 'tool', 'embed', 'exportFileName', 'chartContainerId', 'dataSourceParam', 'width', 'height', 'status'],
  data () {
    return {
      chartLoading: true,
      dataSource: null
    }
  },
  async mounted () {
    try {
      await this.init();
    } finally {
      if (this.status) this.status.ready = true
    }
  },
  computed: {
    imgw () { return this.width || 480 },
    chartElId () { return this.chartContainerId || 'chartContainer' }
  },
  methods: {
    async init () {
      this.$nextTick().then(() => {
        this.chartLoading = true;
        this.dataSource = null;
      })
      await userFileStream(this.dataSourceParam, false, false).then(res => this.dataSource = res)
      this.chartLoading = false;
      if (!this.dataSource) {
        this.$nextTick(() => {
          document.getElementById(this.chartElId).innerHTML = '<p class="text-h3 orange--text">暂无数据</p>';
        })
      }
    },
    onExport () {
      // let dto = this.Utility.clone(this.dataSourceParam);
      // dto.toolTask.resultFile = 'output.zip';
      // userFileStream(dto);
      let dto = this.Utility.clone(this.dataSourceParam);
      dto.toolTask.resultFile = 'output.zip';
      userFileSpeedKey(dto).then(res => {
        let d = res.data || '';
        let speedDownloadUrl = this.Utility.userApi + '/api/pub/file/stream/speed/' + d;
        window.open(speedDownloadUrl);
      })
    }
  }
}

</script>